module.exports = __webpack_public_path__ + "img/Weapon_260.862c4664.png";